if (!customElements.get('component-flavors')) {
  class ComponentFlavors extends HTMLElement {
    constructor() {
      super();

      this.buttonsWrapper = this.querySelector('[data-flavors-buttons]');
      this.defaultButton = this.buttonsWrapper.querySelector('[data-button]');
      this.flavorsItems = this.querySelectorAll('[data-flavors-item]');

      this.buttonsWrapper.addEventListener('click', (e) => {
        if (!e.target.hasAttribute('data-button')) return;

        const button = e.target;

        if (button === this.defaultButton) {
          if (button.classList.contains('is-active')) return;

          this.resetDefaults();

          return;
        }

        button.classList.toggle('is-active');

        const activeButtons = Array.from(
          this.buttonsWrapper.querySelectorAll('[data-button].is-active'),
        );
        if (activeButtons.length === 0) {
          this.resetDefaults();

          return;
        }

        if (activeButtons[0] === this.defaultButton) activeButtons.shift();

        this.defaultButton.classList.remove('is-active');
        this.flavorsItems.forEach((flavorsItem) => {
          const matchesAll = activeButtons.every((activeButton) =>
            flavorsItem.dataset.flavorsItem.includes(
              activeButton.dataset.flavor,
            ),
          );

          flavorsItem.classList.toggle('hidden', !matchesAll);
        });
      });
    }

    resetDefaults() {
      const activeButtons = this.buttonsWrapper.querySelectorAll(
        '[data-button].is-active',
      );

      activeButtons.forEach((activeButton) => {
        activeButton.classList.remove('is-active');
      });
      this.defaultButton.classList.add('is-active');

      this.flavorsItems.forEach((flavorItem) => {
        flavorItem.classList.remove('hidden');
      });
    }
  }

  customElements.define('component-flavors', ComponentFlavors);
}
